const isDev = process.env.NODE_ENV === 'development';

const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    // Always log errors, but could be replaced with Sentry/etc. in production
    console.error(...args);
  },
};

export default logger;
